import api from './api'

export default {
  postLogin (parms) {
    return api.post('auth/login', parms)
  },
  postAutoLogin (parms) {
    return api.post('auth/Autologin', parms)
  },
  getUsers () {
    return api.get('', )
  },
  check(){
    return api.get('auth/check');
  },
  logout(){
    return api.get('auth/logout');
  }
  
}
